var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-ceeyuu-footer"},[_c('a',{staticClass:"a-ceeyuu-footer",attrs:{"href":"https://www.ceeyuu.de","target":"_blank","rel":"noopener"}},[_vm._v(" powered by ")]),_c('img',{staticClass:"img-ceeyuu-footer",attrs:{"src":_vm.CeeYuu_Logo,"alt":"www.ceeyuu.de"},on:{"click":_vm.zuCeeYuu}})])
}
var staticRenderFns = []

export { render, staticRenderFns }